import React from "react";
import AddViajeForm from "./AddViajeForm";

const AddViaje = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Viaje"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddViajeForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddViaje;
